const getFileExtension = (fileName: string): string => {
    const extensionStartLocation = fileName.lastIndexOf('.') + 1;
    return fileName.substring(extensionStartLocation).toLowerCase();
};

export { getFileExtension };
